"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDateInput = exports.GKDateInputContext = void 0;
var react_1 = __importDefault(require("react"));
var gds_ux_components_1 = require("@granular/gds-ux-components");
var common_1 = require("@granular/gds-ux-components/lib/common");
var datepicker_1 = require("@react-aria/datepicker");
var date_1 = require("@internationalized/date");
var datepicker_2 = require("@react-stately/datepicker");
var react_popper_1 = require("react-popper");
var DateField_1 = require("./DateField");
var Calendar_1 = require("./Calendar");
var useBetaMessaging_1 = __importDefault(require("../../common/useBetaMessaging"));
var itemsToIdent = [
    "button",
    "calendar",
    "datefield",
    "label",
    "group",
    "popper",
];
// Giving ourselves a way to set the calendar open state from further within the
exports.GKDateInputContext = react_1.default.createContext({
    setOpenState: function () { return null; },
});
var GKDateInput = function (props) {
    var _a;
    // We're in beta.
    (0, useBetaMessaging_1.default)({
        name: "GKDateInput",
        status: "active",
        releaseDate: "TBD",
        removeDate: "TBD",
        docsAt: "https://design.granular.ag/design-system/components/dateinput",
    });
    // Set up props. Apply defaults and then extract the container props,
    // as they're applied separately and we don't want them being passed
    // to the datepicker state.
    var propsWithDefaults = __assign({ defaultValue: (0, date_1.parseDate)(new Date().toISOString().split("T")[0]) }, props);
    var _b = (0, common_1.mapDefaultProps)(propsWithDefaults, {
        _gkComponentName: "gk-date-input",
    }), id = _b.id, className = _b.className, style = _b.style, QA = _b["data-qa"], datePickerProps = __rest(_b, ["id", "className", "style", "data-qa"]);
    var containerProps = {
        id: id,
        className: className,
        style: __assign(__assign({}, style), { position: "relative" }),
        "data-qa": QA,
    };
    /**
     * Set up some IDs and data-qa tags.
     * The React-Aria hooks provide IDs (and aria-labelledby), but they
     * change every render, which sucks when we have snapshots as
     * part of our default tests. We'll use the data-qa and id props
     * as a base if they were passed; otherwise we'll generate
     * something unique that won't change every render.
     */
    var uniqueID = (0, common_1.usePersistentId2)();
    var baseID = id !== null && id !== void 0 ? id : uniqueID;
    var baseQA = QA !== null && QA !== void 0 ? QA : uniqueID;
    var IDs = {};
    var QAs = {};
    itemsToIdent.forEach(function (suffix) {
        IDs[suffix] = baseID + "--" + suffix;
        QAs[suffix] = baseQA + "--" + suffix;
    });
    // Datepicker setup
    var datePickerState = (0, datepicker_2.useDatePickerState)(datePickerProps);
    var datePickerRef = react_1.default.useRef(null);
    var _c = (0, datepicker_1.useDatePicker)(datePickerProps, datePickerState, datePickerRef), groupProps = _c.groupProps, labelProps = _c.labelProps, fieldProps = _c.fieldProps, buttonProps = _c.buttonProps, dialogProps = _c.dialogProps, calendarProps = _c.calendarProps;
    // Deliberately omiting some React-Aria-specific props.
    // TODO: onPress seems to handle click + keyboard. We need to replace this.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var onPress = buttonProps.onPress, excludeFromTabOrder = buttonProps.excludeFromTabOrder, btnProps = __rest(buttonProps, ["onPress", "excludeFromTabOrder"]);
    // Popper setup
    var _d = react_1.default.useState(null), popperRef = _d[0], setPopperRef = _d[1];
    var _e = react_1.default.useState(null), popperEl = _e[0], setPopperEl = _e[1];
    var _f = (0, react_popper_1.usePopper)(popperRef, popperEl, {
        placement: "bottom-start",
    }), styles = _f.styles, attributes = _f.attributes;
    return (react_1.default.createElement(exports.GKDateInputContext.Provider, { value: { setOpenState: datePickerState.setOpen } },
        react_1.default.createElement(gds_ux_components_1.GKFormGroup, __assign({}, containerProps),
            react_1.default.createElement("div", { ref: setPopperRef },
                react_1.default.createElement(gds_ux_components_1.GKLabel, __assign({}, labelProps, { "data-qa": QAs.label, id: IDs.label }), props.label),
                react_1.default.createElement("div", __assign({ className: "input-group" }, groupProps, { "data-qa": QAs.group, ref: datePickerRef, style: { display: "flex" }, id: IDs.group, "aria-labelledby": IDs.label }),
                    react_1.default.createElement(DateField_1.DateField, __assign({}, fieldProps, { id: IDs.datefield, "data-qa": QAs.datefield, "aria-labelledby": IDs.label })),
                    react_1.default.createElement("div", { className: "input-group-append" },
                        react_1.default.createElement(gds_ux_components_1.GKButton, __assign({}, btnProps, { id: IDs.button, "data-qa": QAs.button, icon: gds_ux_components_1.GKIconName.CalendarToday, onClick: function () { return datePickerState.setOpen(!datePickerState.isOpen); }, "aria-labelledby": IDs.label + " " + IDs.button })))),
                datePickerState.isOpen && (react_1.default.createElement("div", __assign({}, dialogProps, attributes.popper, { ref: setPopperEl, id: IDs.popper, "data-qa": QAs.popper, style: __assign(__assign({}, styles.popper), { minWidth: (_a = datePickerRef === null || datePickerRef === void 0 ? void 0 : datePickerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth }), "aria-labelledby": IDs.label + " " + IDs.popper }),
                    react_1.default.createElement(Calendar_1.Calendar, __assign({}, calendarProps, { "data-qa": QAs.calendar, id: IDs.calendar }))))))));
};
exports.GKDateInput = GKDateInput;
